<div class="textarea-wrapper">
  <label *ngIf="label" class="textarea-label">{{ label | translate }}</label>
  <textarea 
    pInputTextarea
    [(ngModel)]="value"
    [placeholder]="placeholder | translate"
    [disabled]="disabled"
    [rows]="rows"
    [cols]="cols"
    [autoResize]="autoResize"
    [attr.maxlength]="maxlength"
    [ngClass]="{
      'p-filled': variant === 'filled',
      'p-inputtext-sm': false,
      'p-inputtext-lg': false
    }"
    (ngModelChange)="onChange($event)"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
    (input)="handleInput($event)"
    class="custom-textarea">
  </textarea>
  <small *ngIf="maxlength" class="character-count">
    {{ value.length }} / {{ maxlength }}
  </small>
</div>